import axios from 'axios';

const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;

function getHeaders() {
  const token = JSON.parse(localStorage.getItem('accessToken'));
  return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
}

// Todos los métodos siguen el mismo contrato que clinics.service.js:
// { status: 'ok', data } en éxito, { status: 'error', message, httpCode } en error.
// lookup() es POST con el rut en el body (nunca GET ?rut=) porque el backend
// (067-mark-suspicious-entities, pawer-backend) lo expone así deliberadamente
// para no exponer un RUT como query param.
export default class SuspiciousFlagsService {
  static async lookup(rut, entityType) {
    try {
      const response = await axios.post(
        `${ADMIN_URL}/suspicious-flags/lookup`,
        { rut, entityType },
        { headers: getHeaders() }
      );
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      return {
        status: 'error',
        message: error.response?.data?.message ?? error.message,
        httpCode: error.response?.status
      };
    }
  }

  static async create(rut, entityType, reason) {
    try {
      const response = await axios.post(
        `${ADMIN_URL}/suspicious-flags`,
        { rut, entityType, reason },
        { headers: getHeaders() }
      );
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      return {
        status: 'error',
        message: error.response?.data?.message ?? error.message,
        httpCode: error.response?.status
      };
    }
  }

  static async update(rut, entityType, active, reason) {
    try {
      const response = await axios.patch(
        `${ADMIN_URL}/suspicious-flags`,
        { rut, entityType, active, reason },
        { headers: getHeaders() }
      );
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      return {
        status: 'error',
        message: error.response?.data?.message ?? error.message,
        httpCode: error.response?.status
      };
    }
  }
}
